import {
  IPrizesParams,
  IPrizesResponse,
} from '@fantaz/shared/data-access/models';
import { createAction, props } from '@ngrx/store';

export const init = createAction(
  '[Prizes Page] Init',
  props<{ params: IPrizesParams }>(),
);

export const loadPrizesSuccess = createAction(
  '[Prizes/API] Load Prizes Success',
  props<{ prizes: IPrizesResponse }>(),
);

export const loadPrizesFailure = createAction(
  '[Prizes/API] Load Prizes Failure',
  props<{ error: any }>(),
);
